module.exports = __webpack_public_path__ + "img/jack-portrait.f57f918e.png";